import Aside from "../../components/Aside"
import Footer from "../../components/Footer"
import Header from "../../components/Header"
import { useCurrentAccount } from "../../hooks/useCurrentAccount"
import { useEffect, useState } from "react";
import CustomDataTable from "../../components/CustomDataTable"
import { SupportService } from "../../services/SupportService";
import { AlertService } from "../../services/Alert";
import AddModal from "./AddModal";
import useRequest from "../../hooks/useRequest";

function SupportForm() {

    const { call, isRequesting } = useRequest()

    const columns = [
        {
            name: 'id',
            sortable: true,
            selector: row => <p className="text-nowrap p-0">{row.id}</p>,

        },
        {
            name: 'Módulo',
            sortable: true,
            selector: row => row.module_key,

        },
        {
            name: 'Estatus',
            sortable: true,
            formatToExport: row => row.status === 1 ? 'Activo': 'Inactivo',
            selector: row => row.status,
            cell: (row) => {
                return (
                    row.status === 1 ?
                    (
                        <span className="badge bg-soft-info text-info">
                            <span className="legend-indicator bg-info"></span> Activo
                        </span>
                    ) : 
                    (
                        <span className="badge bg-soft-danger text-danger">
                            <span className="legend-indicator bg-danger"></span> Inactivo 
                        </span>
                    )
                )
            }

        },
        {
            name: 'Titulo',
            sortable: true,
            selector: row => row.title,

        },
        {
            name: 'URL',
            sortable: true,
            selector: row => row.url,

        },
        {
            name: 'Acciones',
            sortable: false,
            center: true,
            cell: (row) => {
                return (
                    <div className="btn-group" role="group">
                        <button className="btn bg-soft-info-alternative text-white-dark btn-sm" onClick={() => setShowModal({ show: true, data: row })}>
                            <i className="bi-pencil-fill me-1 text-primary"></i> Editar
                        </button>
                        <div className="btn-group">
                            <button type="button" className="btn bg-soft-info-alternative btn-icon btn-sm dropdown-toggle dropdown-toggle-empty" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <div className="dropdown-menu dropdown-menu-end mt-1" >
                                <button className="dropdown-item" onClick={() => statusLink(row.id, row.status)}>
                                    {
                                        row.status === 1 ? 'Desactivar' : 'Activar'
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

        },

    ]

    const [showModal, setShowModal] = useState({
        show: false,
        data: null
    })

    const [rows, setRows] = useState([]);

    const getHelp = async () => {
        // const { data } = await SupportService.getAll();

        const { data } = await call(SupportService.getAll)
        setRows(data)

    }

    const statusLink = async (id, status) => {
        const isConfirmed = await AlertService.warning('Aviso', `¿Estás seguro de cambiar el estatus del link? Esta acción se puede cambiar en cualquier momento`, async () => {
            try {
                const data = {
                    id_help: id,
                    status: !status
                }
                 status != 0 ? await SupportService.disableLink(data): await SupportService.enableLink(data)
                 await getHelp()
                 AlertService.toastSuccess('Se cambio el estatus del link correctamente.')
            } catch (error) {
                console.log(error)
                AlertService.error('¡Error!', 'No se pudo cambiar el estatus del link, intenta más tarde.')
            }
        });
    }

    const handleShowModal = async (refresh: boolean) => {
        if (refresh) {
            await getHelp()
        }

        setShowModal({ show: false, data: null })
    }

    useEffect(() => {
        getHelp()
    }, [])

    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">
                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >Soporte</span></li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title text-white-dark" onClick={getHelp}><i className="bi bi-question-diamond-fill text-primary"></i> Soporte</h1>
                            </div>
                            <div className="col-sm-auto">
                                <button className="btn btn-primary" onClick={() => setShowModal({ show: true, data: null })}><i className="bi-plus-lg me-1"></i> Agregar link de ayuda</button>
                            </div>
                        </div>
                    </div>


                    <CustomDataTable
                        columns={columns}
                        data={rows}
                        hideAccountsFilter
                        showExport={false}
                        isLoading={isRequesting}
                        filter={(row, term) => {
                            if (!term) return true;

                            return (
                                `${row.id}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.module_key}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.status}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.title}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.url}`.match(new RegExp(`${term}`, 'i'))
                            )
                        }}
                    />

                </div>

                <Footer />
            </main>

            <AddModal
                show={showModal.show}
                onRequestClose={(refresh) => handleShowModal(refresh)}
                payload={showModal.data}
            />
        </>
    )
}
export default SupportForm